import { render, staticRenderFns } from "./AllAccidents.vue?vue&type=template&id=4745406d&scoped=true"
import script from "./AllAccidents.vue?vue&type=script&lang=js"
export * from "./AllAccidents.vue?vue&type=script&lang=js"
import style0 from "./AllAccidents.vue?vue&type=style&index=0&id=4745406d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745406d",
  null
  
)

export default component.exports